import {
  IApplication,
  IApplicationBodyRequest,
  IApplicationResponse,
} from 'models/application';
import { handleRestApiException } from 'utils/handleRestApiException';
import { apiClient } from 'utils/apiClient';
import { isResponseError, TResponse } from 'models/apiClient';
import { ApiEndpoints } from 'models/apiEndpoints';
import { RequestHeaderKeyTypes, RequestHeaderValueTypes } from 'constants/RequestHeaderTypes';
import { IAttachment } from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/WizardSteps/AttachmentsStep';
import { EPerPages, ISortOptions } from 'models/table';
import { queryStringWithSort } from 'helpers/request';

const saveApplicationRequest = async (body: IApplicationBodyRequest) => {
  const config = {
    headers: {
      [RequestHeaderKeyTypes.CONTENT_TYPE]: RequestHeaderValueTypes.MULTIPART_FORM_DATA,
    },
    timeout: 0,
  };
  const formData = new FormData();

  formData.append(
    'request',
    new Blob([JSON.stringify(body.request)], { type: 'application/json' }),
  );

  if (body.attachments) {
    const files = body.attachments.filter(
      (attachment: IAttachment) => attachment.file !== null,
    );
    for (let i = 0; i < files.length; i++) {
      formData.append('attachments', files[i].file, `${files[i].file.name}`);
    }
  }

  try {
    await apiClient.post<TResponse<any>>(ApiEndpoints.SAVE_APPLICATION(), formData, config);

    return {
      success: true,
      data: null,
    };
  } catch (e: any) {
    return {
      success: false,
      data: e?.response?.data,
      responseError: handleRestApiException(e),
    };
  }
};

const getApplicationRequest = async (id: string) => {
  const { data } = await apiClient.get<TResponse<IApplication>>(
    ApiEndpoints.GET_APPLICATION(id),
  );

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

const getApplications = async (
  page: number,
  size: EPerPages,
  sort: ISortOptions | null | undefined,
) => {
  const qString = queryStringWithSort(
    {
      page: page - 1,
      size,
    },
    sort,
  );

  const { data } = await apiClient.get<TResponse<IApplicationResponse>>(
    `${ApiEndpoints.GET_APPLICATIONS()}?${qString}`,
  );

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

export { saveApplicationRequest, getApplicationRequest, getApplications };
